import { ForecastDurationOuomTypeBase } from './base/forecast-duration-ouom-type-base';

export class ForecastDurationOuomType extends ForecastDurationOuomTypeBase { }